<template>
  <search-box :app-list="[{code: 1, name: 'Suraj'}, {code: 2, name: 'jyostna'}]"/>
</template>

<script>
import SearchBox from "../components/search-bar/SearchBar.vue";

export default {
  name: "search-box-wrapper",

  components: {
    SearchBox,
  },
};
</script>
